<template>
  <v-layout wrap>
    <v-flex xs12>
      <AppForm label="抽出条件" />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <CampaignModalPageOfficeIndustry
        ref="industry"
        :menuSetting="menuSetting"
      />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <CampaignModalPageOfficeOptionsCheckbox
        ref="options"
        :menuSetting="menuSetting"
      />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <CampaignModalPageOfficeSelectCondition
        ref="employees"
        :title="'従業員数'"
        :minArray="minTotalEmployeesArray"
        :maxArray="maxTotalEmployeesArray"
        :minInitialVal="employeesTarget.minEmployees"
        :maxInitialVal="employeesTarget.maxEmployees"
        :isValidInitialVal="menuSetting.orderDescription.isValidEmployees"
        @onChangeMinVal="employeesTarget.minEmployees = $event"
        @onChangeMaxVal="employeesTarget.maxEmployees = $event"
        @onChangeIsValid="
          menuSetting.orderDescription.isValidEmployees = $event
        "
      />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <CampaignModalPageOfficeSelectCondition
        ref="salesAmount"
        :title="'売上高規模'"
        :minArray="minTotalSalesArray"
        :maxArray="maxTotalSalesArray"
        :minInitialVal="salesAmountTarget.minSalesAmount"
        :maxInitialVal="salesAmountTarget.maxSalesAmount"
        :isValidInitialVal="menuSetting.orderDescription.isValidSalesAmount"
        @onChangeMinVal="salesAmountTarget.minSalesAmount = $event"
        @onChangeMaxVal="salesAmountTarget.maxSalesAmount = $event"
        @onChangeIsValid="
          menuSetting.orderDescription.isValidSalesAmount = $event
        "
      />
    </v-flex>
    <v-flex xs12 mt-3>
      <AppForm label="対象地域" />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <AppAreaSelector :menuSetting="menuSetting.orderDescription" />
    </v-flex>
    <v-flex xs12 mt-3>
      <AppForm label="備考" />
    </v-flex>
    <v-flex xs10 mt-1 offset-xs1>
      <v-textarea v-model="menuSetting.orderDescription.memo" outline />
    </v-flex>
  </v-layout>
</template>

<script>
import CampaignModalPageOfficeOptionsCheckbox from './CampaignModalPageOfficeOptionsCheckbox'
import CampaignModalPageOfficeIndustry from './CampaignModalPageOfficeIndustry'
import CampaignModalPageOfficeSelectCondition from './CampaignModalPageOfficeSelectCondition'
export default {
  name: 'CampaignModalPageOffice',
  components: {
    CampaignModalPageOfficeOptionsCheckbox,
    CampaignModalPageOfficeSelectCondition,
    CampaignModalPageOfficeIndustry,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting
    },
    employeesTarget() {
      return this.menuSetting.orderDescription.employeesTarget
    },
    salesAmountTarget() {
      return this.menuSetting.orderDescription.salesAmountTarget
    },
    minTotalEmployeesArray() {
      return [
        { name: '1人以上', value: 1 },
        { name: '5人以上', value: 5 },
        { name: '10人以上', value: 10 },
        { name: '20人以上', value: 20 },
        { name: '30人以上', value: 30 },
        { name: '50人以上', value: 50 },
        { name: '100人以上', value: 100 },
        { name: '300人以上', value: 300 },
        { name: '1千人以上', value: 1000 },
        { name: '2千人以上', value: 2000 },
        { name: '3千人以上', value: 3000 },
        { name: '5千人以上', value: 5000 },
        { name: '1万人以上', value: 10000 },
      ]
    },
    maxTotalEmployeesArray() {
      return [
        { name: '上限なし', value: null },
        { name: '5人未満', value: 5 },
        { name: '10人未満', value: 10 },
        { name: '20人未満', value: 20 },
        { name: '30人未満', value: 30 },
        { name: '50人未満', value: 50 },
        { name: '100人未満', value: 100 },
        { name: '300人未満', value: 300 },
        { name: '1千人未満', value: 1000 },
        { name: '2千人未満', value: 2000 },
        { name: '3千人未満', value: 3000 },
        { name: '5千人未満', value: 5000 },
        { name: '1万人未満', value: 10000 },
      ]
    },
    minTotalSalesArray() {
      return [
        { name: '0円', value: 0 },
        { name: '5千万円以上', value: 50000000 },
        { name: '1億円以上', value: 100000000 },
        { name: '5億円以上', value: 500000000 },
        { name: '10億円以上', value: 1000000000 },
        { name: '20億円以上', value: 2000000000 },
        { name: '30億円以上', value: 3000000000 },
        { name: '50億円以上', value: 5000000000 },
        { name: '100億円以上', value: 10000000000 },
        { name: '1000億円以上', value: 100000000000 },
        { name: '5000億円以上', value: 500000000000 },
        { name: '1兆円以上', value: 1000000000000 },
      ]
    },
    maxTotalSalesArray() {
      return [
        { name: '上限なし', value: null },
        { name: '5千万円未満', value: 50000000 },
        { name: '1億円未満', value: 100000000 },
        { name: '5億円未満', value: 500000000 },
        { name: '10億円未満', value: 1000000000 },
        { name: '20億円未満', value: 2000000000 },
        { name: '30億円未満', value: 3000000000 },
        { name: '50億円未満', value: 5000000000 },
        { name: '100億円未満', value: 10000000000 },
        { name: '1000億円未満', value: 100000000000 },
        { name: '5000億円未満', value: 500000000000 },
        { name: '1兆円未満', value: 1000000000000 },
      ]
    },
    errorMessage() {
      const errorMessages = []
      if (this.menuSetting.hasNoConditions) {
        errorMessages.push('抽出条件を指定してください')
      }
      if (!this.$refs.industry.validate()) {
        errorMessages.push('業種分類の条件を一つ以上設定してください')
      }
      if (!this.$refs.options.validate()) {
        errorMessages.push('上場区分の条件を一つ以上設定してください')
      }
      if (!this.$refs.employees.validate()) {
        errorMessages.push('従業員数の数値を正しく設定してください')
      }
      if (!this.$refs.salesAmount.validate()) {
        errorMessages.push('売上高規模の数値を正しく設定してください')
      }
      if (
        this.menuSetting.orderDescription.area.isEmpty(
          this.menuSetting.orderDescription.administrativeDistrictType,
        )
      ) {
        errorMessages.push('対象地域を指定してください')
      }
      return errorMessages.length === 0 ? '' : errorMessages
    },
  },
}
</script>

<style scoped>
.v-textarea >>> textarea {
  margin-top: 0;
}
</style>
